import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import {
  DDG_CAPTCHA_SITE_KEY,
  isDdgCaptchaTestMode,
  loadDdgCaptchaApi,
  testCaptchaToken,
} from '../lib/ddgCaptcha';

let slotSeq = 0;

const DdgCaptcha = forwardRef(function DdgCaptcha({ onToken }, ref) {
  const hostRef = useRef(null);
  const widgetIdRef = useRef(null);
  const onTokenRef = useRef(onToken);
  const slotIdRef = useRef(`ddg-captcha-${++slotSeq}`);
  onTokenRef.current = onToken;

  useImperativeHandle(ref, () => ({
    reset() {
      const widgetId = widgetIdRef.current;
      if (widgetId != null && window.ddgcaptcha?.reset) {
        window.ddgcaptcha.reset(widgetId);
      }
      onTokenRef.current('');
    },
  }));

  useEffect(() => {
    let cancelled = false;
    onTokenRef.current('');

    if (isDdgCaptchaTestMode()) {
      onTokenRef.current(testCaptchaToken());
      return undefined;
    }

    loadDdgCaptchaApi()
      .then((api) => {
        if (cancelled || !hostRef.current) return;
        widgetIdRef.current = api.render(slotIdRef.current, {
          sitekey: DDG_CAPTCHA_SITE_KEY,
          callback: (token) => onTokenRef.current(token || ''),
        });
      })
      .catch(() => {
        if (!cancelled) onTokenRef.current('');
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      id={slotIdRef.current}
      ref={hostRef}
      data-testid="ddg-captcha"
      className="min-h-[70px]"
    />
  );
});

export default DdgCaptcha;
